'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dEdit$002dGrouping$002dPage$0024 from "./presto.-Edit-Grouping-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002455 from "./presto.-Presto-Router$$anon$55.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dId$0024 from "./presto.types$-Grouping-Id$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dName$0024 from "./presto.types$-Grouping-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$54() {
  this.bk9 = null;
  this.bk1 = null;
  this.bk2 = false;
  this.bka = null;
  this.bkb = false;
  this.bke = null;
  this.bk7 = null;
  this.bk8 = false;
  this.bk3 = null;
  this.bk4 = false;
  this.bk5 = null;
  this.bk6 = false;
  this.bkc = false;
  this.bkd = false;
  this.bk9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bke = "EditGroupingPage";
}
export { $c_Lpresto_PrestoRouter$$anon$54 as $c_Lpresto_PrestoRouter$$anon$54 };
$p = $c_Lpresto_PrestoRouter$$anon$54.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$54;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$54() {
}
export { $h_Lpresto_PrestoRouter$$anon$54 as $h_Lpresto_PrestoRouter$$anon$54 };
$h_Lpresto_PrestoRouter$$anon$54.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bk9;
});
$p.L = (function() {
  if ((!this.bk2)) {
    this.bk1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bk2 = true;
  }
  return this.bk1;
});
$p.O = (function() {
  if ((!this.bkb)) {
    this.bka = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bkb = true;
  }
  return this.bka;
});
$p.E = (function() {
  return this.bke;
});
$p.t = (function() {
  if ((!this.bk8)) {
    this.bk7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("global", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bk8 = true;
  }
  return this.bk7;
});
$p.M = (function() {
  if ((!this.bk4)) {
    this.bk3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dId$0024.$m_Lpresto_types$GroupingId$().nJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dName$0024.$m_Lpresto_types$GroupingName$().nK(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().ar, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bk4 = true;
  }
  return this.bk3;
});
$p.Q = (function() {
  if ((!this.bk6)) {
    this.bk5 = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002455.$c_Lpresto_PrestoRouter$$anon$55();
    this.bk6 = true;
  }
  return this.bk5;
});
$p.w = (function() {
  if ((!this.bkd)) {
    this.bkc = false;
    this.bkd = true;
  }
  return this.bkc;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee414) => ((p) => \u03b4scrutinee414.cG5(p)))($j_presto$002e$002dEdit$002dGrouping$002dPage$0024.$m_Lpresto_EditGroupingPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$54 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$54, "presto.PrestoRouter$$anon$54", ({
  Om: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$54 as $d_Lpresto_PrestoRouter$$anon$54 };
//# sourceMappingURL=presto.-Presto-Router$$anon$54.js.map
